<template>
  <div class="AnchorPoint" id="top" data-anchor-name="top" data-anchor-offset="true"></div>
  <div class="ScrollingSticky">
    <div v-if="type != 'none'" class="ScrollingSticky__cta">
      <a class="etx-button Button focus" :class="style" :href="link" :title="linkLabel">
        <div class="etx-button__text Button__text">
          <span>{{ linkLabel }}</span>
        </div>
        <div class="etx-button__icon Button__icon">
          <i class="far fa-long-arrow-right"></i>
        </div>
      </a>
    </div>
    <div class="ScrollingSticky__top">
      <a class="LinkAnchor" href="#top">
        <i class="far fa-long-arrow-up"></i>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
  type?: string
}>()

const initData: Ref<InitData> = await useInitData()
const { globalConfig } = initData.value

const style = computed(() => {

  if (props?.type === 'carreer') {
    return 'color-primary'
  }

  if (props?.type === 'apprenticeships') {
    return 'color-orange'
  }

  return ''
})

const link = computed(() => {

  if (props?.type === 'carreer') {
    return globalConfig?.ctaCarreerLink?.uri?.path
  }

  if (props?.type === 'apprenticeships') {
    return globalConfig?.ctaApprenticeshipsLink?.uri?.path
  }

  return globalConfig?.ctaDefaultLink?.uri?.path
})

const linkLabel = computed(() => {

  if (props?.type === 'carreer') {
    return globalConfig?.ctaCarreerLabel
  }

  if (props?.type === 'apprenticeships') {
    return globalConfig?.ctaApprenticeshipsLabel
  }

  return globalConfig?.ctaDefaultLabel
})

onMounted(() => {
  if (typeof initScrollingSticky === 'function') {
    initScrollingSticky();
  }
});

</script>
